import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getVendors(params: any): AxiosPromise {
    return EndPointService.get('/vendors', { params });
}
function getVendorsSmall(params: any): AxiosPromise {
    return EndPointService.get('/vendors-simply-list', { params });
}

function getVendor(id: number | string): AxiosPromise {
    return EndPointService.get(`/vendors/${id}`);
}

function deleteVendor(id: number | string): AxiosPromise {
    return EndPointService.delete(`/vendors/${id}`);
}

function createVendor(payload: any): AxiosPromise {
    return EndPointService.post('/vendors', payload);
}

function deleteFileVendor(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/vendor_docs/${fileId}`);
}

function createFilesVendor(data: any): AxiosPromise {
    return EndPointService.post(`/vendor_docs`, data);
}

function getFilesVendor(id: string | number): AxiosPromise {
    return EndPointService.get(`/vendor_docs`, {
        params: {
            'vendor.id': id,
        },
    });
}

function updateVendor(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/vendors/${id}`, { ...payload });
}

export default {
    getVendors,
    getVendorsSmall,
    getFilesVendor,
    createFilesVendor,
    deleteFileVendor,
    getVendor,
    deleteVendor,
    createVendor,
    updateVendor,
};
